import type { IHttpClient } from './types/httpClient.interface';
import { HttpClientService } from './httpClientService';

/**
 * Base API Instance (Framework Agnostic)
 * 
 * Abstract base class for all API services.
 * Provides access to the HTTP client through a clean interface.
 */
export abstract class ApiInstance {
  private _httpClient: IHttpClient;
  protected _httpClientService: HttpClientService;

  constructor(httpClientService?: HttpClientService) {
    this._httpClientService = httpClientService || new HttpClientService();
    this._httpClient = this._httpClientService.client;
  }

  /**
   * Get the HTTP client instance
   * API classes use this to make requests
   */
  public get api(): IHttpClient {
    return this._httpClient;
  }

  /**
   * Create an abort controller for request cancellation
   */
  public createAbortController(): AbortController {
    return this._httpClientService.createAbortController();
  }

  /** @deprecated Use createAbortController instead */
  public generateCancelTokenSource() {
    return this._httpClientService.generateCancelTokenSource();
  }
}
